import { DefaultTheme } from 'styled-components/dist/types';

type makeRatingIconsDataProps = (theme: DefaultTheme) => { [key: string]: any };

export const makeRatingIconsData: makeRatingIconsDataProps = (
  theme: DefaultTheme,
) => ({
  unsatisfactory: {
    icon: 'check',
    iconType: 'fas',
    label: 'Unsatisfactory',
    color: theme.color.feature.rating.unsatisfactory,
  },
  inadequate: {
    icon: 'check',
    iconType: 'fas',
    label: 'Inadequate',
    color: theme.color.feature.rating.inadequate,
  },
  notPublished: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Not published',
    color: theme.color.feature.rating.notPublished,
  },
  weak: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Weak',
    color: theme.color.feature.rating.weak,
  },
  registered: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Registered',
    color: theme.color.feature.rating.registered,
  },
  adequate: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Adequate',
    color: theme.color.feature.rating.adequate,
  },
  requiresImprovement: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Requires improvement',
    color: theme.color.feature.rating.requiresImprovement,
  },
  good: {
    icon: 'circle',
    iconType: 'fas',
    label: 'Good',
    color: theme.color.feature.rating.good,
  },
  veryGood: {
    icon: 'star',
    iconType: 'fas',
    label: 'Very good',
    color: theme.color.feature.rating.veryGood,
  },
  excellent: {
    icon: 'star',
    iconType: 'fas',
    label: 'Excellent',
    color: theme.color.feature.rating.excellent,
  },
  outstanding: {
    icon: 'star',
    iconType: 'fas',
    label: 'Outstanding',
    color: theme.color.feature.rating.outstanding,
  },
});
